export const contest = {
  qjy: '貿易',
  grbm: '個人戦エントリー',
  qdl: 'ログイン',
  bsyjs: 'ゲームは終りだ',
  bsjs: '競争は終わりました',
  djs: '秒読み',
  days: 'D ',
  hours: 'H ',
  minutes: 'M ',
  seconds: 'S',
  ljyq: '招待する',
  tdbm: 'チーム戦エントリー',
  qzc: '登録',
  qrsfgrbm: '個人登録に参加するかどうか確認しますか？',
  qxbm: 'キャンセル',
  qrbm: '確認する',
  gxnbmcg: 'おめでとうございます。登録が成功しました。10W USDT の模擬資金を受け取ります',
  xzjs: 'なりたいキャラクターを選択してください',
  cwty: 'メンバー',
  cwtz: 'リーダー',
  cjtd: 'チームを作成する',
  jtgz: 'グループ構築ルール:',
  jtgz1: '1.結成後24時間以内にメンバーが5人に満たないグループは自動的に解散され、模擬個人戦に自動登録されます',
  jtgz2: '2.グループ結成待機中は模擬個人戦への参加登録はできません',
  jtgz3: '3.チームを結成した後は、他のチームに参加したり、個人戦をシミュレートしたりすることはできません',
  tdmc: 'チームの名前：',
  tdjj: 'チームプロフィール：',
  ljjt: '作成する',
  tdmcbt: 'チーム名を入力してください',
  tdjzbt: 'チームプロフィールを入力してください',
  cjzdcg: 'チームが正常に作成されました!',
  xzjrtd: '参加したいチームを選択してください',
  sstdmc: 'チーム名を検索する',
  dqzdsl: '現在のチーム数: {v1}、参加したいチームを選択してください',
  ddtdrs: '現在のチームの規模: {v1} 人',
  tdrs: 'チームの規模：',
  tzmc: 'チームリーダー名：',
  jrtd: '参加する',
  jrzdcg: '無事にチームに加わりました！',
  grfxlj: '個人共有リンク：',
  grtjm: '紹介コード：',
  tdfxlj: 'チーム共有リンク：',
  tdtjm: '紹介コード：：',
  tdtzm: '船長名：',
  bctp: '保存',
  total: '合計 {v1} 個',
  dd: 'に',
  qd: 'もちろん',
  cyyj: '参加者報酬',
  jcdnn: 'USDTの巨額な賞金プールを山分け!',
  jzcj: '利益寄付、抽選に参加',
  dqjc: '現在のプール総額：',
  qjz: '寄付に行く',
  jzsm: '利益寄付について',
  kjz: '現在、{v1} USDT 慈善基金に寄付できます。寄付してもよろしいですか?',
  qxjz: 'キャンセル',
  qrjz: '寄付の確認',
  jzcg: 'おめでとうございます，寄付は成功しました！',
  mnpjyds: 'デモトレード大会',
  bm: 'サインアップ：',
  bs: 'コンテスト：',
  hyspjyds: '先物トレード大会',
  xhspjyds: '現物トレード大会',
  bmz: '登録中です',
  jqqd: '乞うご期待',
  bsz: 'ゲームで',
  yjs: '仕上げる',
  myptts: 'チーム戦デモトレード大会',
  mypzmxs: '週間スターチームランキング',
  mypgrs: '個人戦デモトレード大会',
  hyjyds: '先物トレード大会',
  xhjyds: '現物トレード大会',
  my: '私の',
  pm: 'ランキング',
  dync: 'チームニックネーム',
  dm: 'チームの名前',
  zdrs: 'チーム数',
  nc: 'ニックネーム',
  ljzjy: '累計取引総額',
  ljzjye: '総取引量',
  ljzyll: '累計総利益率',
  zyll: '総収益性',
  zdjl: 'チームの報酬',
  mypbsjl: '参加者報酬',
  myphycs: 'デモトレード大会の参加者',
  myhyj: '参加者に100,000U相当のデモ先物ボーナスを獲得',
  ljbm: '今すぐ参加してください',
  tzjl: 'チーム参加報酬',
  ztcg: '一つのチームに対して5～200名となり',
  bwzbhl: 'チームリーダーが100000U以上のボーナスを獲得できます',
  yqjl: '招待報酬',
  yqhycybs: 'チームリーダーからの招待、最大100000Uが獲得できます',
  hzhyj: 'チームメンバーからの招待、最大50000Uが獲得できます',
  mnttbssm: 'シミュレーションコンテストチーム競技ルール説明',
  // 团队赛规则
  csxq: '大会内容：',
  csxq1: '1、大会の開始日から終了日まで、ユーザー（実名認証が必要）は自由にチームを結成できます。チームの人数が5人以上、200人以下にしなければならないです。24時間以内にチームメンバーが5人に満たない場合、自動的に解散され、チームメンバーは個人戦のエリアに自動的に参加することになります。',
  csxq2: '2、ユーザーは1つのチームのみを選択できます、複数参加することはできません。チーム戦と個人戦は同時に参加することもできません、ユーザーがチームに入りましたら自発的に退出することはできません。',
  ssgz: '大会ルール：',
  ssgz1: '1、チームリーダーの特典：1）チームリーダーは、メンバーを1人招待するごとに、1000USDT相当のデモ取引ボーナスを獲得できます。最大100,000USDT相当ボーナスがもらえます。',
  ssgz1_2: '          2）チームリーダーは20人以上を招待し、そして招待された人が取引を行った場合は、BiKingの周辺アイテムをもらえます。',
  ssgz2: '2、チームメンバーの特典：チームメンバーは、1人招待するごとに500USDT相当のデモ取引ボーナスを獲得できます。最大50,000USDT相当ボーナスがもらえます',
  ssgz3: '3、チーム大会が終了した後、各チームの実際の総取引量を基づいて最終的な順位を判定します',
  ssgz4: '4、大会でチームの総取引額は毎日0時に更新されます',
  ssgz5: '5、大会結果の公正性を確保するために、不正な取引やトレードデータの偽造などが発覚した場合、参加資格が取り消される権利を有します',
  ssgz6: '6、詳細な規則については、BiKingのサポートチームにお問い合わせください',
  jlfp: '報酬規則：',
  jlfp1: '1、USDTボーナスの分配：（ボーナスの配布は、常に先物ボーナスと現金を9：1の比率で分配されます）',
  jlfp1_1: '1）チーム内の分配比率：',
  jlfp1_2: 'チームリーダーのボーナス=リーダーの個人累計取引量/BiKingチーム戦の総取引量×5000000USDT+',
  jlfp1_3: '+チーム内に他のメンバーの実績の合計/BiKingチーム戦の総取引量×20%×5000000USDT',
  jlfp1_4: 'チームメンバーのボーナス=ユーザーの現在累計先物取引量/Bikingチーム戦の総取引量×80%×5000000USDT',
  jlfp1_5: '2）大会期間中に優れたチームは、更に団体収益ボーナスをプラスされます！収益ボーナスの比率は、チームの人数とチームの総取引量を基づいて判定します、チームの人数/総取引量で、倍増するたびに、50%のハッシュレートボーナスを受けることができます！',
  myptdjyze: 'シミュレーション競技チーム部門の総取扱高',
  myptdphb: 'シミュレーション競技チームランキング',
  tdsl: '現在のチーム数: {v1}、参加したいチームを選択してください',
  tznc: 'リーダー：',
  tdjs: 'チーム紹介：',
  // 周明星规则
  mypzmxgzsm: 'シミュレーションコンテストウィークリースターコンペティションルール説明',
  zmxphb: 'チームランキング（上位3名のみ）',
  zmxtdphb: '週間スターチームランキング',
  bdxq: '詳細：',
  bdxq1: '1、チームの結成と取引を開始しましたら、デフォルトで週ベストチームランキングに参加することになります。',
  zmxgz: '1、システムは月曜日から金曜日までの1サイクルとし、各チームの週間総取引量に基づいてランク付きます、それから「週ベストチームランキング」を公表します。ランキングの上位3つのチームは2000000USDTのデモ取引ボーナスを山分けします',
  zmxgz1: '2、週間ベストチームランキングは毎週水曜日14:00に更新されます',
  bddym: '1位には1000000USDT相当のデモ取引ボーナス',
  dbdem: '2位には600000USDT相当のデモ取引ボーナス',
  bddsm: '3位には400000USDT相当のデモ取引ボーナス',
  tdnbfpgz: 'チーム内の報酬規則：',
  tzx: 'チームリーダー：20%；',
  nbyjpm: 'チーム内で取引量に基づいて前10位メンバー（リーダー以外）：40%山分け',
  syty: 'その他のメンバー：40%山分け',
  // 个人赛规则
  mypgrsgzsm: 'デモトレード大会個人戦について',
  mypgrphb: 'デモトレード大会個人戦ランキング',
  bsxz: '詳細：',
  bsxz1: '1、新規登録の参加者は100,000 USDT相当のデモ取引ボーナスを受け取ります',
  bsxz2: '2、既存ユーザーの参加者は50,000 USDT相当のデモ取引ボーナスを受け取ります',
  bsxz3: '2、大会期間中、更に招待報酬を受け取ることができます：',
  bsxz4: '1）新しいユーザーをコンテストに参加するよう招待するたびに、2,000 USDT シミュレーション契約ボーナスを受け取ります',
  // bsxz5: '2）1人招待するごとに、2,000 USDT相当のデモ取引ボーナスを獲得できます',
  bsxz6: '2）招待ボーナスは最大50,000 USDTとなっています',
  bsxz7: '3、本大会はBiKing取引所の実名ユーザーのみ対象です',
  bsxz8: '4、大会終了後、各参加者の最終取引量を基準にして順位が決定されます',
  grgzsm1: '1、賞金プール：2000000 USDT + 周辺アイテム30個',
  grgzsm2: '2、分配詳細：',
  grgzsm3: '第1位：800000 USDT + 周辺アイテム5個',
  grgzsm4: '第2位：500000 USDT+ 周辺アイテム5個',
  grgzsm5: '第3位：200000 USDT + 周辺アイテム3個',
  grgzsm6: '第4位-第20位：山分け500000 USDT + 周辺アイテム17個',
  hyjybs: '先物トレード大会',
  hyjybsgzsm: '先物トレード大会について',
  hyspgrphb: '先物トレード大会ランキング',
  // 合约大赛规则
  csxz: '詳細：',
  hybsgz1: '1、先物トレード大会に参加登録しましたら100USDT相当のボナースを受け取ることができます（ボナースの使用規則はプラットフォームの報酬規則を参照してください）。ボーナスでの取引利益は、大会期間中の総収益率に含まれません',
  hybsgz2: '2、招待報酬は1人招待するごとに20USDT相当ボーナスが獲得できます、最大100USDTまでとなっています',
  hybsgz3: '3、本大会はBiKing取引所の実名ユーザーのみ対象です。',
  hybsgz4: '4、大会終了後、各参加者の期間中の総収益率を基準にして順位が決定されます。',
  jcfp: '報酬：',
  jcfp1: '賞金プール：2000000USDT+周辺アイテム30個',
  fpgz: 'ボーナスの配布：',
  fpgzs: '（常に先物ボーナスと現金を9：1の比率で分配されます）',
  fpgz1: '第1位：800000USDT+周辺アイテム5個',
  fpgz2: '第2位：500000USDT+周辺アイテム5個',
  fpgz3: '第3位：200000USDT+周辺アイテム3個',
  fpgz4: '第4位-第20位：山分け500000USDT+周辺アイテム17個',
  hjyq: '報酬規則',
  hjyq1: '1、先物トレード大会利益額＝アカウントの最終純資産（未実現損益を含む）－アカウントの初期純資産（未実現損益を含む）－ボーナス獲得総額',
  hjyq2: '2、利益額が同じ場合、取引量が多い方が上位となります',
  hjyq3: '3、優勝者はアカウント利益額が0より大きいことを満たす必要があります',
  // 捐赠
  gyc1: '寄付プールは、先物トレード大会のユーザーおよび現物トレード大会のユーザーのみ開設されており、ユーザーは大会の終了前に中止することができ、その際の取引額/収益率は寄付プールに振込となります',
  gyc2: 'システムは、各収益率×0.5USDTの割合での寄付金を寄付プールに振込を行います',
  gyc3: '寄付金額は大会ページで公開されます、例えばユーザーAが実際の収益率が38％場合、そのユーザーが寄付すると、システムは寄付プールに38×0.5=19USDTを振込となります（寄付金は先物ボーナスとなります）',
  gyc4: '寄付プールの累計上限金額：50000USDT相当の先物ボーナスまで',
  gyc5: 'ユーザーが取引額を寄付する場合、システムは100USDTの取引額ごとに0.5USDTの割合で寄付プールに寄付を行います。例えば、ユーザーBの総取引額が1000USDTの場合、寄付金は0.5USDT×10=5USDT（寄付金は先物ボーナスとなります）',
  gyc7: '注意点：各ユーザーは公益寄付に1回のみ参加でき、一度寄付できましたら、ユーザーはBikingトレード大会のランキング資格、受賞資格、および参加資格を放棄したものと見なされます（先物トレード大会のユーザーは公益寄付後、現物トレード大会に参加できません）',
  gyc8: '大会終了後、寄付プールは3回の抽選が行われ、毎回に10人が抽選され、賞金を均等に分配されます。3回の賞金分配の割合は、40%、30%、30%です',
  gyc9: '抽選の日時：賞品は取引大会終了後7営業日以内にランダムに抽選されます。詳細については、公式のスタッフにお問い合わせください',
  xhjybs: '現物トレード大会',
  xhjybsgzsm: '現物トレード大会について',
  xhjydsphb: '現物取引競争ランキング',
  grbmcg: '個人登録が成功しました！',
  // 现货实大赛规则
  xhgz1: '1、 スポット取引のコンペティションには、プラットフォーム上のすべてのスポット取引ペアが含まれています。',
  xhgz2: '2、大会に参加するユーザーは、プラットフォームの現物口座残高が50USDT以上の必要があります',
  xhgz3: '3、大会終了後、プラットフォームはユーザーの現物総取引額を基準にして、順位が決定されます',
  jjfp: '報酬：',
  zjc: '賞金プール：1000000USDT+周辺アイテム20個',
  xhdym: '第1位：400000USDT+周辺アイテム10個',
  xhdem: '第2位：200000USDT+周辺アイテム5個',
  xhdsm: '第3位：100000USDT+周辺アイテム５個',
  xhdsm1: '第4位-第20位：300000USDT山分け',
  mypdnpm: 'チーム内部ランキング',
  yqjl1: '招待報酬',
  wdjye: '私の取引額：',
  wdzsyl: '私のトータルリターン：',
  grzjyl: '個人取引総額：',
  grzsyl: '個人の総収益：',
  sqzjye: '地域内の総取引量：',
  zjye: '地域内の総取引量：',
  bsyqrs: 'コンテストへの招待者数：',
  ren: '人々',
  hdmnj: '模擬ゴールド：',
  hdzj: 'ボーナスをゲット：',
  hyjyxq: '契約取引競争の詳細',
  xhjyxq: '現物取引コンテストの詳細',
  hy: '契約',
  xh: 'スポットグッズ',
  jlsm: '報酬の説明',
  jlsm1: '1.大会中、ユーザー（実名認証必須）は任意にグループを立ち上げることができますが、契約チーム大会はチーム人数が5人以上、200人以下の条件を満たす必要があり、グループ終了後24時間以内にグループが5人に達しない場合は、が開始されると、チームは自動的に解散されます',
  jlsm2: '2.各人は 1 つのチームのみに参加でき、重複は許可されず、自発的にチームを辞めることはできません',
  tdjye: 'チームのトランザクション量：',
  wdjs: '自分の役割：',
  dz: 'チームリーダー',
  dy: 'チームメンバー',
  tdzyll: 'チーム全体の収益性：',
  wdzyll: '私の総利益率：',
  tdyjhdjl: 'チームは報酬を受け取る予定：',
  tdjs1: 'チーム紹介',
  grxq: '個人情報',
  tdxq: 'チーム詳細',
  tdjylpm: 'チーム取引量ランキング: ',
  tdzsyl: 'チーム合計利益率',
  tdnphb: 'チーム内ランキング',
  tcsybs: 'Tips: 寄付が完了すると、すべてのコンテストから退場します',
  zwcjhybs: '模擬契約競争にまだ参加していない',
  zwsj: 'データなし',
  tdmcbzq: 'チーム名の形式が正しくありません',
  tdjjbzq: 'チームプロフィールの形式が正しくありません',
  hdjxz_contract: '永久契約取引コンテストが本格化したら、コンテストに参加して 2,000,000U の賞金プールを共有し、寛大な BiKing 周辺機器を獲得してください',
  hdjxz_spot: 'スポット取引コンテストが本格化したら、コンテストに参加して 1,000,000U の賞金プールを分け合って、豪華な BiKing 周辺機器を獲得してください',
  hdjs: '次回の対戦にもご期待ください',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/ja_JP.js